<vc-spinner *ngIf="loading"></vc-spinner>

<div
   *ngIf="!loading"
   class="outer-container peer-page">
   <!-- Link problems -->
   <div
      *ngIf="errorMessage"
      class="cycle-closed-notice"
      style="width: 100%">
      <i class="fa fa-lock cycle-closed-notice__icon"></i>
      <div class="cycle-closed-notice__body">
         <span class="cycle-closed-notice__title">{{ errorMessage }}</span>
      </div>
   </div>

   <ng-container *ngIf="request && template">
      <div class="grid-container top-info">
         <!-- Who and what -->
         <vc-rounded-card
            class="namesCard"
            titleSize="large"
            style="flex: 0.7; position: relative">
            <div class="mainHeader">
               Peer Input for
               <span style="color: #818181">{{ request.revieweeName }}</span>
            </div>

            <p class="peer-page__intro">
               <span style="font-weight: 700; color: #0672ba">{{ request.requestedByName }}</span>
               asked for your input on this {{ roleLabel }} review. Answer the questions the way you see this person's work; skip anything you can't
               speak to. Your answers go only to {{ request.requestedByName }}. {{ request.revieweeName }} will not see them.
            </p>

            <div class="name-container">
               <div class="info-grid">
                  <div class="info-item">
                     <div class="item-heading">{{ roleLabel }}</div>
                     <div class="item-value">{{ request.revieweeName }}</div>
                  </div>
                  <div class="info-item">
                     <div class="item-heading">Hospital</div>
                     <div class="item-value">{{ request.practiceName || "---" }}</div>
                  </div>
                  <div class="info-item">
                     <div class="item-heading">Requested by</div>
                     <div class="item-value">{{ request.requestedByName }}</div>
                  </div>
               </div>
            </div>
         </vc-rounded-card>

         <!-- Status & actions -->
         <vc-rounded-card
            colorClass="v-blue"
            class="versionsCard"
            style="flex: 0.3">
            <div class="date-container">
               <div class="vc-header">
                  <h3 class="vc-title">
                     <i
                        class="vc-icon"
                        aria-hidden="true"></i>
                     Status
                  </h3>
               </div>

               <hr />

               <div
                  class="mt-3"
                  style="display: flex; flex-direction: column; gap: 5px">
                  <div class="submitted-info">Requested on {{ formatDate(request.requestedOn) }}</div>

                  <ng-container *ngIf="request.status === 'Submitted'">
                     <div
                        class="submitted-info"
                        style="color: #ffffff">
                        Submitted on {{ formatDate(request.submittedOn) }}
                     </div>
                     <button class="v-button v-button-lg v-teal disabled mt-2">
                        <i class="fa fa-check-circle"></i>
                        &nbsp;Input Submitted
                     </button>
                  </ng-container>

                  <ng-container *ngIf="canEdit">
                     <div
                        class="submitted-info"
                        *ngIf="request.updatedOn">
                        Draft saved {{ formatDate(request.updatedOn) }}
                     </div>
                     <button
                        class="v-button v-button-lg v-white mt-4"
                        [disabled]="isSaving"
                        (click)="save(false)">
                        <i class="fa fa-file-text-o"></i>
                        &nbsp;Save as Draft
                     </button>
                     <button
                        class="v-button v-button-lg v-teal mt-1"
                        [disabled]="isSaving"
                        (click)="save(true)">
                        <i class="fa fa-cloud-upload"></i>
                        &nbsp;Submit Input
                     </button>
                  </ng-container>

                  <div
                     class="continueEditing"
                     style="margin-top: 15px; padding-left: 0px; padding-right: 0px; font-size: 14px; line-height: 22px"
                     *ngIf="!request.isPeer">
                     View only. This request was sent to {{ request.peerName }}, so only they can fill it out.
                  </div>
               </div>
            </div>
         </vc-rounded-card>
      </div>

      <!-- The questions: same component and layout as the manager's side of the review -->
      <div class="not-merged-view">
         <review-assessment-sections
            #peerSections
            [userReview]="userReview"
            [template]="template"
            mode="reviewer"
            [reviewType]="request.reviewType"
            [canEditReviewee]="false"
            [canEditReviewer]="canEdit"
            [additionalResponsibilities]="additionalResponsibilities"
            [includeCareerExploration]="true"
            [isPrimaryReviewee]="false"
            (dataChanged)="onDataChanged($event)"></review-assessment-sections>
      </div>

      <div
         class="peer-page__footer"
         *ngIf="canEdit">
         <button
            class="v-button v-button-lg v-white"
            [disabled]="isSaving"
            (click)="save(false)">
            <i class="fa fa-file-text-o"></i>
            &nbsp;Save as Draft
         </button>
         <button
            class="v-button v-button-lg v-teal mt-1"
            [disabled]="isSaving"
            (click)="save(true)">
            <i class="fa fa-cloud-upload"></i>
            &nbsp;Submit Input
         </button>
      </div>
   </ng-container>
</div>
